import TeyaseerArticleSection from './TeyaseerArticleSection';

export { default as TeyaseerArticleSectionTheme } from './TeyaseerArticleSection.style';
export default TeyaseerArticleSection;
